import 'babel-polyfill';

// import './scripts/react-big-calendar';

import './client/thirdparty/bootstrap';

import './client/worldmap';


